export default __webpack_public_path__ + "static/media/icon9.a118ad03.svg";